import ReactModal from 'react-modal';
import styled from 'styled-components';
import { Component, ReactNode } from 'react';
import Fade from 'components/common/animations/fade';
import { Row, Col } from 'components/common/grid';
import { HeaderTwo } from 'components/common/headers';
import { ClickableIcon } from 'components/common/buttons';

import { connect } from 'react-redux';
import { closeModal } from './modal-actions';

const BlueHeader = styled(Row)`
  position: relative;
  width: 100%;
  background: ${props => props.theme.colors.siteNavy};
  height: 61px;
  color: ${props => props.theme.colors.white};
  font-size: 2rem;
  padding-left: 50px !important;
  font-family: ${props => props.theme.fonts.montserratSemiBold};
`;
const CloseIcon = styled(ClickableIcon).attrs({
  name: 'x'
})`
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 4rem;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  z-index: 1;
  .icon {
    color: ${props => props.theme.colors.black};
    position: absolute;
    top: 1px;
    left: 0;
  }
`;

type Modal = {
  component: ReactNode;
  title: string;
  modalClassName: string;
  overlayOnly: boolean;
  onClose: () => void;
  keepOpen: boolean;
  onclose?: () => void;
  noCloseIcon?: boolean;
  noCloseOnOverlay?: boolean;
  type: string;
  onAfterOpen: () => void;
};

type ModalWindowProps = {
  closeModal: () => void;
  modals: Array<Modal>;
  className: string;
};

export class ModalWindow extends Component<ModalWindowProps> {
  constructor(props: ModalWindowProps) {
    super(props);
    ReactModal.setAppElement('body');
  }

  render(): ReactNode {
    if (this.props.modals.length <= 0) {
      return null;
    }
    return (
      <div>
        {this.props.modals.map((modal: Modal) => {
          const {
            component,
            title,
            modalClassName,
            overlayOnly,
            onClose,
            onclose,
            keepOpen,
            type,
            onAfterOpen,
            noCloseOnOverlay,
            noCloseIcon
          } = modal;
          return (
            <ReactModal
              key={`${title}`}
              isOpen
              contentLabel={title || 'Modal Window'}
              onRequestClose={() => {
                if (onClose) {
                  onClose();
                }
                if (onclose) {
                  onclose();
                }
                if (keepOpen || noCloseOnOverlay) {
                  return;
                }
                this.props.closeModal();
              }}
              onAfterOpen={() => {
                if (onAfterOpen) {
                  onAfterOpen();
                }
              }}
              portalClassName={`${modalClassName} ${type} ${this.props.className} ${
                overlayOnly && 'overlayOnly'
              }`}
              overlayClassName="modalOverlay"
              bodyOpenClassName="modalOpenBodyClass"
              {...this.props}
            >
              <Fade>
                <Row as="section" justifyCenter>
                  {!overlayOnly && (
                    <>
                      {!noCloseIcon && (
                        <CloseIcon
                          className="closeButton"
                          onClick={() => {
                            if (onClose) {
                              onClose();
                            }
                            if (keepOpen) {
                              return;
                            }
                            this.props.closeModal();
                          }}
                        />
                      )}
                      {type === 'blueHeader' && title && (
                        <BlueHeader alignCenter>{title}</BlueHeader>
                      )}
                      {type !== 'blueHeader' && (
                        <Col className="titleCol">
                          <HeaderTwo>{title}</HeaderTwo>
                        </Col>
                      )}
                    </>
                  )}
                  <Col xs="100" noPadding>
                    {component}
                  </Col>
                </Row>
              </Fade>
            </ReactModal>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = ({ modal }: any) => ({
  modals: modal
});

export default connect(mapStateToProps, {
  closeModal
})(ModalWindow);
